import {
  FirestoreDataConverter,
  QueryDocumentSnapshot,
  SnapshotOptions,
  WithFieldValue,
  DocumentData,
} from 'firebase/firestore';
import type { Tournament, Participant, Match } from './types';

// Тип "как лежит в Firestore" — без `id`, т.к. id берётся из имени документа.
type TournamentDoc = Omit<Tournament, 'id'>;
type ParticipantDoc = Omit<Participant, 'id'>;
type MatchDoc = Omit<Match, 'id'>;

export const tournamentConverter: FirestoreDataConverter<Tournament> = {
  toFirestore(t: WithFieldValue<Tournament>): DocumentData {
    const { id: _id, ...rest } = t as Tournament;
    return rest;
  },
  fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions): Tournament {
    const data = snapshot.data(options) as TournamentDoc;
    return { id: snapshot.id, ...data };
  },
};

export const participantConverter: FirestoreDataConverter<Participant> = {
  toFirestore(p: WithFieldValue<Participant>): DocumentData {
    const { id: _id, ...rest } = p as Participant;
    return rest;
  },
  fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions): Participant {
    const data = snapshot.data(options) as ParticipantDoc;
    return { id: snapshot.id, ...data };
  },
};

export const matchConverter: FirestoreDataConverter<Match> = {
  toFirestore(m: WithFieldValue<Match>): DocumentData {
    const { id: _id, ...rest } = m as Match;
    return rest;
  },
  fromFirestore(snapshot: QueryDocumentSnapshot, options: SnapshotOptions): Match {
    const data = snapshot.data(options) as MatchDoc;
    return { id: snapshot.id, ...data };
  },
};
